import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DeliveryType} from '../model/delivery-type';


@Pipe({
    name: 'deliveryType',
    standalone: true
})
export class DeliveryTypePipe implements PipeTransform {

  constructor(private readonly translate: TranslateService) {
  }

  transform(value: DeliveryType | null | undefined): string {
    if (value !== undefined && value !== null) {
      switch (value) {
        case DeliveryType.Hotfix:
          return this.translate.instant('delivery-type-pipe.hotfix');
        case DeliveryType.ServiceRelease:
          return this.translate.instant('delivery-type-pipe.service_release');
        case DeliveryType.ServiceReleaseAndHotfix:
          return this.translate.instant('delivery-type-pipe.service_release_and_hotfix');
        case DeliveryType.MainRelease:
        case DeliveryType.CompactRelease:
          return this.translate.instant('delivery-type-pipe.main_release');
        default:
          return this.translate.instant('delivery-type-pipe.default');
      }
    }
    return this.translate.instant('delivery-type-pipe.default');
  }

}
